import React, { useState } from 'react';

import { MemberBadge } from '../../../types/entity.types';

import Button from '../button/Button';
import Image from '../image/Image';
import Modal from '../modal/Modal';

import './badges.scss';

type Props = {
  badges?: MemberBadge[];
  badgeReferences: string[];
  retrieveBadges: (onSuccess: () => void) => void;
};

const Badges = ({ badgeReferences, badges, retrieveBadges }: Props) => {
  const [showModal, setShowModal] = useState(false);

  const handleBadgeClick = () => {
    retrieveBadges(() => {
      setShowModal(true);
    });
  };
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <span className="badges-inline" onClick={handleBadgeClick}>
        {badgeReferences.map((src, index) => (
          <Image key={index} src={src} testId="badge" />
        ))}
      </span>

      <Modal show={showModal}>
        <section className="badge-details">
          <p className="badge-details__heading">Badges</p>

          <section className="badge-details__content">
            {badges
              ?.filter((badge) => badge.badgeCount > 0)
              .map((badge, index) => (
                <div key={index} className="badge-details__item">
                  <Image src={badge.iconExternalReference!} />
                  <span className="badge-details__name">
                    {badge.badgeCount > 1 ? `x${badge.badgeCount} ` : null}
                    {badge.badgeName}
                  </span>
                </div>
              ))}
          </section>

          <Button text={'Close'} onClick={handleCloseModal} />
        </section>
      </Modal>
    </>
  );
};

export default Badges;
